import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
/**
 * This service purpose to provide up-to-date state
 * of the actual snapshot.
 *
 * Details: When we inject ActivatedRoute we get the
 * ActivatedRoute at that level of the component tree
 * where it's injected, meaning there is not one instance
 * of it, there's many.
 */
export class ActivatedRoute {
    constructor(router) {
        this.router = router;
    }
    get activatedRoute() {
        return this.router.routerState.root;
    }
    get snapshot() {
        return this.activatedRoute.snapshot;
    }
    // eslint-disable-next-line rxjs/finnish
    get queryParams() {
        return this.activatedRoute.queryParams;
    }
    // eslint-disable-next-line rxjs/finnish
    get queryParamMap() {
        return this.activatedRoute.queryParamMap;
    }
}
ActivatedRoute.ɵfac = function ActivatedRoute_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ActivatedRoute)(i0.ɵɵinject(i1.Router)); };
ActivatedRoute.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ActivatedRoute, factory: ActivatedRoute.ɵfac, providedIn: 'root' });
